import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, IUtilsDictionary, LoggingService, UtilsJson, UtilsMisc, UtilsString } from '@pit/core';
import { EntityDataService } from '@pit/core-data';
import { DtoContact, DtoDepot, DtoDevice, IDtoContact, IDtoDepot, IDtoDevice } from '@pit/frontend-model';
import { map, Observable } from 'rxjs';
import { IDtoDepotEntityDataService } from '../interfaces/dto.depot.entity.data.service.interface';

@Injectable({
  providedIn: 'root'
})
export class DtoDepotEntityDataService extends EntityDataService<IDtoDepot> implements IDtoDepotEntityDataService {

  constructor(http: HttpClient, configService: ConfigService, loggingService: LoggingService) {
    super(http, null, configService, loggingService);
  }

  public getDevicesForMandatorAndDepot$(mandator: string, depot: IDtoDepot): Observable<IDtoDevice[]> {
    const url: string = `/api/web/depots/mandator/${mandator}/${depot.numberDepot}/devices`
    return this.httpGet(url)
      .pipe(map((entities: IDtoDevice[]) => {
        const result: IDtoDevice[] = [];
        if ((UtilsMisc.isNullOrUndefined(entities) === false) && (entities.length > 0)) {
          for (const entity of entities) {
            result.push((UtilsJson.deserialize(entity, DtoDevice) as IDtoDevice));
          }
        }
        return result;
      }));
  }

  public async getDevicesForMandatorAndDepotAsync(mandator: string, depot: IDtoDepot): Promise<IDtoDevice[]> {
    return (await this.getDevicesForMandatorAndDepot$(mandator, depot).toPromise());
  }

  public getDepotsForMandator$(mandatorId: number): Observable<IDtoDepot[]> {
    return this.httpGet(`/api/web/depots/mandator/${mandatorId}`)
      .pipe(map((entities: IDtoDepot[]) => {
        const result: IDtoDepot[] = [];
        if ((UtilsMisc.isNullOrUndefined(entities) === false) && (entities.length > 0)) {
          for (const entity of entities) {
            result.push(this.createEntityFromJson(entity));
          }
        }
        return result;
      }));
  }

  public async getDepotsForMandatorAsync(mandatorId: number): Promise<IDtoDepot[]> {
    return (await this.getDepotsForMandator$(mandatorId).toPromise());
  }

  public saveDepotContactForMandator$(mandator: string, depot: IDtoDepot, contact: IDtoContact): Observable<IDtoContact> {
    const url: string = `/api/web/depots/mandator/${mandator}/${depot.numberDepot}/contacts`;
    return this.httpPost(url, contact)
      .pipe(map((json: IDtoContact) => {
        let result: IDtoContact = null;
        if (UtilsMisc.isNullOrUndefined(json) === false) {
          result = (UtilsJson.deserialize(json, DtoContact) as IDtoContact);
        }
        return result;
      }));
  }

  public async saveDepotContactForMandatorAsync(mandator: string, depot: IDtoDepot, contact: IDtoContact): Promise<IDtoContact> {
    return (await this.saveDepotContactForMandator$(mandator, depot, contact).toPromise());
  }

  protected override doGetApiUrl(): string {
    return UtilsString.stringFormat('{0}/depots', this.configurationService.configData.urlApi);
  }

  protected override createEntityFromJson(json: any): IDtoDepot {
    const result: IDtoDepot = (UtilsJson.deserialize(json, DtoDepot) as IDtoDepot);
    if (result !== null) {
      result.setReferences();
    }

    return result;
  }

  protected override doGetUrls(): IUtilsDictionary<string> {
    this._urls = super.doGetUrls();

    this._urls.add('get.depot.devices', UtilsString.stringFormat('{0}://{1}:{2}/{3}', this.configurationService.configData.protocol, this.configurationService.configData.ip, this.configurationService.configData.port, this.apiUrl));
    this._urls.add('get.depots.by.mandator', UtilsString.stringFormat('{0}://{1}:{2}/{3}/mandator/', this.configurationService.configData.protocol, this.configurationService.configData.ip, this.configurationService.configData.port, this.apiUrl) + '{0}');
    this._urls.add('save.contact', UtilsString.stringFormat('{0}://{1}:{2}/{3}', this.configurationService.configData.protocol, this.configurationService.configData.ip, this.configurationService.configData.port, this.apiUrl));

    return this._urls;
  }

}
